/**
 * PFR Form Redirect Handler
 * Generates PDF with pdf-lib, captures signature, sends to Cloudflare Worker
 */
(function () {
  'use strict';

  const WORKER_URL = 'https://pfr-form-handler.cristi-cb6.workers.dev';
  const PDF_TEMPLATE_URL = 'https://cdn.shopify.com/s/files/1/0967/1455/5779/files/230_Completat.pdf?v=1772546782';

    // PDF coordinate map (calibrated v5)
  const PDF_COORDS = {
    nume:        { x: 77,  y: 663 },
    initialaTata:{ x: 298, y: 663 },
    prenume:     { x: 77,  y: 643 },
    strada:      { x: 77,  y: 621 },
    numar:       { x: 295, y: 620 },
    bloc:        { x: 68,  y: 599 },
    scara:       { x: 120, y: 599 },
    etaj:        { x: 160, y: 599 },
    ap:          { x: 196, y: 599 },
    judet:       { x: 261, y: 599 },
    localitate:  { x: 78,  y: 578 },
    codPostal:   { x: 280, y: 578 },
    cnpStart:    { x: 337, y: 655, spacing: 17.4 },
    email:       { x: 364, y: 632 },
    telefon:     { x: 364, y: 605 },
    signature:   { x: 142, y: 110,  width: 110, height: 23 },
  };

  const FONT_SIZE = 7;

  let signaturePad = null;

  // ========== INIT ==========
  function init() {
    const form = document.querySelector('.form-redirect-form form');
    if (!form) return;

    // Verify external libraries actually loaded. If a CDN was blocked
    // (adblock / ISP / corporate firewall), surface a clear error instead
    // of letting the form fall back to native /contact submission.
    if (typeof window.SignaturePad === 'undefined' || typeof window.PDFLib === 'undefined') {
      console.error('[PFR Form] Required libraries failed to load:', {
        SignaturePad: typeof window.SignaturePad,
        PDFLib: typeof window.PDFLib
      });
      var errEl = document.getElementById('form-redirect-error');
      if (errEl) {
        errEl.textContent = 'Aplicația nu s-a încărcat complet. Reîncărcați pagina (Ctrl+F5). Dacă problema persistă, dezactivați adblocker-ul pe acest site.';
        errEl.style.display = 'block';
      }
      return;
    }

    initSignaturePad();
    initFormHandler(form);

    // Mark form as ready and enable submit button. The inline failsafe in
    // the section liquid checks this flag in capture phase to block native
    // /contact submission before this point.
    window.__pfrFormReady = true;
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn) {
      btn.removeAttribute('aria-busy');
      var loadingSpan = btn.querySelector('.submit-btn__loading');
      var readySpan = btn.querySelector('.submit-btn__ready');
      if (loadingSpan) loadingSpan.style.display = 'none';
      if (readySpan) readySpan.style.display = '';
    }
  }

  // ========== SIGNATURE PAD ==========
  function initSignaturePad() {
    const canvas = document.getElementById('signature-canvas');
    if (!canvas || typeof SignaturePad === 'undefined') return;

    // Set canvas resolution for sharp rendering
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    canvas.getContext('2d').scale(ratio, ratio);

    signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)',
      penColor: 'rgb(0, 0, 0)',
      minWidth: 0.5,
      maxWidth: 2.5,
    });

    // Clear button
    const clearBtn = document.getElementById('signature-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        signaturePad.clear();
      });
    }

    // Handle resize
    window.addEventListener('resize', function () {
      const data = signaturePad.toData();
      const newRect = canvas.getBoundingClientRect();
      canvas.width = newRect.width * ratio;
      canvas.height = newRect.height * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      signaturePad.clear();
      if (data.length > 0) signaturePad.fromData(data);
    });
  }

  // ========== FORM HANDLER ==========
  function initFormHandler(form) {
    // Listen for custom event dispatched by section's failsafe inline script
    // after it captures and preventDefaults the native submit.
    form.addEventListener('pfr-form-submit', async function (e) {

      const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      // Use innerHTML to preserve embedded SVG icon during submitting state.
      const originalHtml = submitBtn ? (submitBtn.tagName === 'BUTTON' ? submitBtn.innerHTML : submitBtn.value) : '';

      try {
        // Validate signature
        if (!signaturePad || signaturePad.isEmpty()) {
          showError('Va rugam sa semnati formularul.');
          return;
        }

        // Collect form data
        const data = collectFormData(form);
        if (!data) return;

        // Show loading
        if (submitBtn) {
          submitBtn.disabled = true;
          var submittingText = (submitBtn.dataset && submitBtn.dataset.submittingText) || 'Se trimite...';
          if (submitBtn.tagName === 'BUTTON') submitBtn.innerHTML = submittingText;
          else submitBtn.value = submittingText;
        }

        // Generate PDF
        const pdfBytes = await generatePDF(data, signaturePad.toDataURL('image/png'));

        // Convert to base64
        const pdfBase64 = arrayBufferToBase64(pdfBytes);

        // Build form summary for admin email
        const formSummary = [
          { label: 'Nume', value: data.nume },
          { label: 'Prenume', value: data.prenume },
          { label: 'CNP', value: data.cnp },
          { label: 'Email', value: data.email },
          { label: 'Telefon', value: data.telefon },
          { label: 'Adresa', value: [data.strada, data.numar, data.localitate, data.judet].filter(Boolean).join(', ') },
          { label: 'Perioada', value: data.perioada || '1 an' },
        ];

        // Submit to Worker
        const response = await fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            pdfBase64: pdfBase64,
            userName: data.nume + ' ' + data.prenume,
            userEmail: data.email,
            formSummary: formSummary,
          }),
        });

        const result = await response.json();

        if (result.success) {
          showSuccess();
          form.reset();
          if (signaturePad) signaturePad.clear();
        } else {
          throw new Error(result.error || 'Eroare la trimitere');
        }
      } catch (err) {
        console.error('Form submit error:', err);
        showError('A aparut o eroare: ' + err.message + '. Va rugam incercati din nou.');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (submitBtn.tagName === 'BUTTON') submitBtn.innerHTML = originalHtml;
          else submitBtn.value = originalHtml;
        }
      }
    });
  }

  // ========== COLLECT FORM DATA ==========
  function collectFormData(form) {
    const get = function (name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      return el ? el.value.trim() : '';
    };

    const data = {
      nume: get('Nume').toUpperCase(),
      prenume: get('Prenume').toUpperCase(),
      initialaTata: get('Initiala Tatalui') ? get('Initiala Tatalui').toUpperCase() : '',
      cnp: get('CNP'),
      email: get('Email'),
      telefon: get('Telefon'),
      strada: get('Strada').toUpperCase(),
      numar: get('Numar'),
      bloc: get('Bloc').toUpperCase(),
      scara: get('Scara'),
      etaj: get('Etaj'),
      ap: get('Ap'),
      judet: get('Judet').toUpperCase(),
      localitate: get('Localitate').toUpperCase(),
      codPostal: get('Cod Postal'),
      perioada: get('Perioada'),
    };

    // Validate required fields
    if (!data.nume) { showError('Campul Nume este obligatoriu.'); return null; }
    if (!data.prenume) { showError('Campul Prenume este obligatoriu.'); return null; }
    if (!data.cnp || data.cnp.length !== 13) { showError('CNP-ul trebuie sa aiba 13 cifre.'); return null; }
    if (!data.email || !data.email.includes('@')) { showError('Adresa de email este invalida.'); return null; }
    if (!data.telefon) { showError('Campul Telefon este obligatoriu.'); return null; }

    return data;
  }

  // ========== PDF GENERATION ==========
  async function generatePDF(data, signatureDataUrl) {
    var PDFLib = window.PDFLib;
    if (!PDFLib) throw new Error('PDF library not loaded');

    // Fetch template
    var templateResponse = await fetch(PDF_TEMPLATE_URL);
    var templateBytes = await templateResponse.arrayBuffer();

    // Load PDF
    var pdfDoc = await PDFLib.PDFDocument.load(templateBytes);
    var page = pdfDoc.getPages()[0];
    var font = await pdfDoc.embedFont(PDFLib.StandardFonts.Helvetica);
    var black = PDFLib.rgb(0, 0, 0);
    var sz = FONT_SIZE;

    // Section I — User data (left column)
    page.drawText(data.nume, { x: PDF_COORDS.nume.x, y: PDF_COORDS.nume.y, size: sz, font: font, color: black });

    if (data.initialaTata) {
      page.drawText(data.initialaTata, { x: PDF_COORDS.initialaTata.x, y: PDF_COORDS.initialaTata.y, size: sz, font: font, color: black });
    }

    page.drawText(data.prenume, { x: PDF_COORDS.prenume.x, y: PDF_COORDS.prenume.y, size: sz, font: font, color: black });
    page.drawText(data.strada, { x: PDF_COORDS.strada.x, y: PDF_COORDS.strada.y, size: sz, font: font, color: black });

    if (data.numar) {
      page.drawText(data.numar, { x: PDF_COORDS.numar.x, y: PDF_COORDS.numar.y, size: sz, font: font, color: black });
    }
    if (data.bloc) {
      page.drawText(data.bloc, { x: PDF_COORDS.bloc.x, y: PDF_COORDS.bloc.y, size: sz, font: font, color: black });
    }
    if (data.scara) {
      page.drawText(data.scara, { x: PDF_COORDS.scara.x, y: PDF_COORDS.scara.y, size: sz, font: font, color: black });
    }
    if (data.etaj) {
      page.drawText(data.etaj, { x: PDF_COORDS.etaj.x, y: PDF_COORDS.etaj.y, size: sz, font: font, color: black });
    }
    if (data.ap) {
      page.drawText(data.ap, { x: PDF_COORDS.ap.x, y: PDF_COORDS.ap.y, size: sz, font: font, color: black });
    }

    page.drawText(data.judet, { x: PDF_COORDS.judet.x, y: PDF_COORDS.judet.y, size: sz, font: font, color: black });
    page.drawText(data.localitate, { x: PDF_COORDS.localitate.x, y: PDF_COORDS.localitate.y, size: sz, font: font, color: black });

    if (data.codPostal) {
      page.drawText(data.codPostal, { x: PDF_COORDS.codPostal.x, y: PDF_COORDS.codPostal.y, size: sz, font: font, color: black });
    }

    // Section I — Right column: CNP digits
    if (data.cnp && data.cnp.length === 13) {
      for (var i = 0; i < 13; i++) {
        page.drawText(data.cnp[i], {
          x: PDF_COORDS.cnpStart.x + (i * PDF_COORDS.cnpStart.spacing),
          y: PDF_COORDS.cnpStart.y,
          size: sz, font: font, color: black
        });
      }
    }

    // Email & Phone
    page.drawText(data.email.toLowerCase(), { x: PDF_COORDS.email.x, y: PDF_COORDS.email.y, size: sz, font: font, color: black });
    page.drawText(data.telefon, { x: PDF_COORDS.telefon.x, y: PDF_COORDS.telefon.y, size: sz, font: font, color: black });

    // Signature — embed PNG image
    if (signatureDataUrl) {
      var sigBytes = dataUrlToUint8Array(signatureDataUrl);
      var sigImage = await pdfDoc.embedPng(sigBytes);
      var sigCoords = PDF_COORDS.signature;

      // Scale signature to fit the box while preserving aspect ratio
      var sigDims = sigImage.scale(1);
      var scaleW = sigCoords.width / sigDims.width;
      var scaleH = sigCoords.height / sigDims.height;
      var scale = Math.min(scaleW, scaleH);

      var drawW = sigDims.width * scale;
      var drawH = sigDims.height * scale;
      var drawX = sigCoords.x + (sigCoords.width - drawW) / 2;
      var drawY = sigCoords.y + (sigCoords.height - drawH) / 2;

      page.drawImage(sigImage, {
        x: drawX,
        y: drawY,
        width: drawW,
        height: drawH,
      });
    }

    return await pdfDoc.save();
  }

  // ========== HELPERS ==========
  function arrayBufferToBase64(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';
    for (var i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  function dataUrlToUint8Array(dataUrl) {
    var base64 = dataUrl.split(',')[1];
    var binary = atob(base64);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  function showError(message) {
    var errEl = document.getElementById('form-redirect-error');
    if (errEl) {
      errEl.textContent = message;
      errEl.style.display = 'block';
      errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      alert(message);
    }
    // Hide after 8 seconds
    setTimeout(function () {
      if (errEl) errEl.style.display = 'none';
    }, 8000);
  }

  function showSuccess() {
    // Hide form, show success message (Shopify native pattern)
    var formContainer = document.querySelector('.form-redirect-form');
    var successEl = document.getElementById('form-redirect-success');
    if (formContainer) formContainer.style.display = 'none';
    if (successEl) successEl.style.display = 'block';
  }

  // ========== START ==========
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
